<template>
	<BaseModal
		:title="t('title')"
		v-model="show"
		@transitionShow="setTransitionShow"
		@close="onClose()"
		noPadding
	>
		<div class="px-5">
			<SearchInput v-model="localSearch" @enter="enter" ref="input" />
		</div>
		<BottomActionsModal class="mt-5 pt-4">
			<BaseButton size="lg" color="primary" class="w-full" @click="enter()">
				{{ t('confirm') }}
			</BaseButton>
		</BottomActionsModal>
	</BaseModal>
</template>
<script setup lang="ts">
import BaseModal from './BaseModal.vue'
import { ref, watch, nextTick, onBeforeMount } from 'vue'
import SearchInput from '../SearchInput.vue'
import { useI18n } from 'vue-i18n'
import BaseButton from '../BaseButton.vue'
import BottomActionsModal from '../BottomActionsModal.vue'
import { sleep } from '@/utils/sleep'

const { t } = useI18n({
	messages: {
		en: {
			title: 'search',
			confirm: 'confirm'
		},
		ru: {
			title: 'поиск',
			confirm: 'подтвердить'
		}
	}
})

let transitionShow = false

const setTransitionShow = async (value: boolean) => {
	transitionShow = value

	await nextTick()

	if (show.value) {
		focusInput()
	}
	if (!show.value) {
		focusOut()
	}
}

const show = defineModel<boolean>('show')
const search = defineModel<string>('search')

const localSearch = ref<string>()

const input = ref<InstanceType<typeof SearchInput>>()

const focusInput = async () => {
	if (!transitionShow) {
		return
	}

	await nextTick()
	await sleep(10)

	if (!input.value) {
		return
	}

	input.value.focusInput()
}

const focusOut = async () => {
	if (transitionShow) {
		return
	}

	await nextTick()

	if (!input.value) {
		return
	}

	input.value.focusOut()
}

watch(show, () => {
	if (!show.value) {
		focusOut()
		return
	}

	localSearch.value = search.value

	focusInput()
})

const onClose = () => {
	search.value = (localSearch.value || '').trim()
	localSearch.value = ''
}

const enter = () => {
	show.value = false
	onClose()
}
</script>
